import { CSSProperties, useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../services/api'
import TableHeader from './Header'
import Pagination from './Pagination'
import Search from './Search'
import { LinkContainer } from './style'
import { useUpdateDataTable } from '../../hooks/dataTable'
import { useLoading } from '../../hooks/loading'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { labelChangedAuditDataTable } from 'utlis/labelsChangedAuditDataTable'
import { numericMask } from 'utlis/mask'

interface Action {
  name: string
  icon?: IconDefinition
  spanIcon?: string
  htmlIcon?: JSX.Element
  title: string
  link?: string
  classname?: string
  activeClassname?: string
  style?: CSSProperties
  onClick?: (params: any) => void
  hasIcon?: (params: any) => boolean
  linkTo?: (params: any) => string
}

interface Header {
  name: string
  field: string
  sortable: boolean
  download?: {
    fileName?: string
    fileUrl?: string
  }
  hasTypes?: {
    types?: any
  }
  concat?: {
    field: string
    position: 'start' | 'end'
  }
}

interface SearchParameters {
  [key: string]: string
}

interface DataTableProps {
  onActions?: {
    onClickButtonEdit?: <T>(currentValue: T | any) => void
    onClickButtonRemove?: <T>(currentValue: T | any) => void
    onClickButtonList?: <T>(currentValue: T | any) => void
  }
  entity: string
  source: string
  headers?: Header[]
  actions?: Action[]
  notHasChildren?: boolean
  onlyParent?: boolean
  notParent?: boolean
  onlyView?: boolean
  parentId?: string
  viewField?: { source: string; field: string }
  entityId?: string
  searchParameters?: SearchParameters[]
  showParentId?: boolean
  format: {
    orderBy: string
  }
  excludeColumn?: string
  excludeKey?: string
  activeItems?: number[]
}

const DataTable = ({
  onActions,
  entity,
  source,
  notHasChildren,
  viewField,
  onlyView,
  onlyParent,
  notParent,
  excludeColumn,
  excludeKey,
  headers = [
    { name: 'Data', field: 'created_at', sortable: true },
    { name: 'Usuário', field: 'user.name', sortable: false },
    { name: 'Descrição', field: 'descriptions', sortable: true },
    { name: 'Ação', field: 'type', sortable: true }
  ],
  actions,
  format,
  parentId,
  entityId,
  searchParameters,
  showParentId,
  activeItems
}: DataTableProps): JSX.Element => {
  const [items, setItems] = useState<any[]>([])
  const [filterItems, setFilterItems] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [search, setSearch] = useState('')
  console.log('o')
  const [ItemsPerPage, setItemsPerPage] = useState(50)
  const { isUpdated } = useUpdateDataTable()
  const [pageChange, setPageChange] = useState(false)
  const { activeLoading, disableLoading } = useLoading()
  const handlerOnClickButtonList = (currentValue: any) => {
    if (viewField) {
      return `/${viewField.source}/view/${currentValue[viewField.field]}?tab=${
        currentValue.id
      }`
    }

    if (typeof onActions?.onClickButtonList === 'function') {
      onActions.onClickButtonList(currentValue)
    } else {
      return `/${source}/view/${currentValue.id}`
    }
  }

  const handlerOnClickButtonEdit = (currentValue: any) => {
    return `/${source}/update/${currentValue.id}`
  }

  const handlerOnClickButtonRemove = (currentValue: any) => {
    if (onActions?.onClickButtonRemove) {
      onActions.onClickButtonRemove(currentValue)
    }
  }
  const loadParams = useCallback(() => {
    const params = {
      entity,
      source,
      keyword: search ? { [format.orderBy]: search } : '',
      page: currentPage,
      perPage: ItemsPerPage,
      orderByField: '',
      searchParameters:
        searchParameters?.length > 0 ? searchParameters : undefined,
      onlyParent,
      notParent,
      orderBy: format.orderBy,
      parentId,
      entityId,
      excludeColumn,
      excludeKey
    }

    if (!parentId) Object.assign(params, { parentId: '' })
    if (!entityId) Object.assign(params, { entityId: '' })

    return params
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ItemsPerPage,
    currentPage,
    entity,
    entityId,
    excludeColumn,
    excludeKey,
    format.orderBy,
    onlyParent,
    notParent,
    parentId,
    searchParameters,
    source
  ])
  const isDoubleSearch = search && searchParameters
  // UseEffect pra pesquisas que não envolvem FILTRO/SEARCH
  useEffect(() => {
    ;(async () => {
      if (search || isDoubleSearch) {
        return
      }
      try {
        isDoubleSearch && activeLoading()
        const params = loadParams()
        const response = await api.get('dataTable', { params })
        setItems(response.data.items)
        setFilterItems(response.data.items)
        setTotalItems(response.data.totalItens)
        setCurrentPage(response.data.page)
        isDoubleSearch && disableLoading()
      } catch (error) {
        isDoubleSearch && disableLoading()
        console.error(error)
      }
    })()
  }, [loadParams, isUpdated, activeLoading, disableLoading, search])

  // UseEffect pra quando atualiza o filtro
  useEffect(() => {
    ;(async () => {
      try {
        activeLoading()
        const params = loadParams()
        const response = await api.get('dataTable', {
          params: { ...params, page: 1 }
        })
        setItems(response.data.items)
        setFilterItems(response.data.items)
        setTotalItems(response.data.totalItens)
        setCurrentPage(response.data.page)
        disableLoading()
      } catch (error) {
        disableLoading()
        console.error(error)
      }
    })()
  }, [searchParameters])

  const firstItem =
    totalItems === 0 ? totalItems : ItemsPerPage * (currentPage - 1) + 1
  const getTotalItems = (initialValue: number): number => {
    let sum = 0
    if (initialValue > 1) {
      return items.length + initialValue - 1
    } else {
      if (notHasChildren) {
        sum = items.reduce((sum, value) => {
          if (!showParentId && !value.parent_id) {
            return sum + 1
          }
          if (showParentId) {
            return sum + 1
          }
          return sum
        }, 0)
      } else {
        sum = items.length
      }
    }
    return sum
  }

  const getSearched = async (value: string) => {
    const params = loadParams()

    const newParams = {
      ...params,
      keyword: { [params.orderBy]: value },
      page: 1
    }
    console.log(newParams)
    const response = await api.get('dataTable', {
      params: newParams
    })
    setItems(response.data.items)
    // console.log(response.data)
    setTotalItems(response.data.totalItens)

    setCurrentPage(1)
  }

  let timeOutId: NodeJS.Timeout
  const onSearchItem = async (value: string) => {
    if (value.length === 0) {
      setItems(filterItems)
      clearTimeout(timeOutId)
      return
    }

    clearTimeout(timeOutId)
    timeOutId = setTimeout(() => getSearched(value), 0)
  }

  const handleDownload = useCallback((item: any, header: Header) => {
    let filename = item[header.download.fileName]
    const indexTrace = filename.indexOf('-') + 1
    filename = filename.slice(indexTrace, filename.length)
    fetch(`${item[header.download.fileUrl]}`).then(response => {
      response.blob().then((blobObject: any) => {
        const url = window.URL.createObjectURL(blobObject)
        const a = document.createElement('a')
        a.download = filename
        a.href = url
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
    })
  }, [])

  return (
    <div id="kt_datatable">
      <div className="card-header p-0 py-5 gap-2 gap-md-5">
        <div className="">
          <div id="kt_datatable" className="dataTables_length">
            <label>
              <select
                onChange={e => {
                  setItemsPerPage(Number(e.target.value))
                  setCurrentPage(1)
                }}
                className="form-select form-select-solid form-select-sm fw-boldl"
              >
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
              <p className="">resultados por página</p>
            </label>
          </div>
        </div>
        <div className="gap-5 d-flex flex-column">
          <div className="dataTables_filter d-flex align-items-center">
            <label
              className="fw-bolder pe-2 fs-6 text-gray-800"
              htmlFor="search"
            >
              Pesquisar
            </label>
            <Search
              isPageChanged={pageChange}
              search={search}
              setSearch={setSearch}
              setIsPageChanged={setPageChange}
              onSearch={value => onSearchItem(value)}
            />
          </div>
          <div className="dataTables_paginate paging_bootstrap_number d-flex justify-content-end">
            <Pagination
              total={totalItems}
              itemsPerPage={ItemsPerPage}
              currentPage={currentPage}
              onPageChange={page => setCurrentPage(page)}
              setIsPageChanged={setPageChange}
            />
          </div>
        </div>
      </div>

      <div className="table-scrollable dataTable">
        <table
          id="kt_datatable"
          className="dataTable table table-striped table-row-bordered gs-3 border table-hover"
        >
          <TableHeader
            headers={headers}
            onSorting={(field, order) => {
              const itemSorted = items.sort((a, b) => {
                const fields = field.split('.')
                let currentFieldA
                let currentFieldB
                if (fields.length === 1) {
                  currentFieldA = a[fields[0]]
                  currentFieldB = b[fields[0]]
                }
                if (fields.length === 2) {
                  currentFieldA = a[fields[0]]?.[fields[1]]
                  currentFieldB = b[fields[0]]?.[fields[1]]
                }
                if (fields.length === 3) {
                  currentFieldA = a[fields[0]]?.[fields[1]]?.[fields[2]]
                  currentFieldB = b[fields[0]]?.[fields[1]]?.[fields[2]]
                }
                if (fields.length === 4) {
                  currentFieldA =
                    a[fields[0]]?.[fields[1]]?.[fields[2]]?.[fields[3]]
                  currentFieldB =
                    b[fields[0]]?.[fields[1]]?.[fields[2]]?.[fields[3]]
                }
                return currentFieldA > currentFieldB && order === 'ASC' ? 1 : -1
              })
              setItems([...itemSorted])
            }}
          />
          <tbody>
            {(items.length > 0 &&
              items.map(item => {
                const types = [
                  { key: 'locacao', label: 'LOCAÇÃO' },
                  { key: 'L', label: 'LOCAÇÃO' },
                  { key: 'materia-prima', label: 'MATERIA PRIMA' },
                  { key: 'revenda', label: 'REVENDA' },
                  { key: 'semi-acabado', label: 'SEMI ACABADO' },
                  { key: 'consumo', label: 'USO E CONSUMO' },
                  { key: 'CONSUMO', label: 'USO E CONSUMO' },
                  { key: 'venda', label: 'VENDA' },
                  { key: 'V', label: 'VENDA' },
                  { key: 'C', label: 'Crédito' },
                  { key: 'D', label: 'Débito' }
                ]
                if (
                  item.payament_form &&
                  typeof item.payament_form === 'string'
                ) {
                  item.payament_form = JSON.parse(item.payament_form)
                  if (item.payament_form.value) {
                    item.payament_form.value = numericMask(
                      item.payament_form.value.toString()
                    )
                  }
                }
                const typeProduct = types.find(
                  t => t.key === item.product?.type
                )
                if (typeProduct) {
                  item.product.type = typeProduct.label
                }
                const type = types.find(t => t.key === item.type)
                if (type) {
                  item.type = type.label
                }
                return (
                  <tr key={item.id}>
                    {headers.map(
                      header =>
                        (header?.field === 'descriptions' &&
                          entity === 'AuditLog' && (
                            <td
                              key={`${header?.field}-${item.id}`}
                              className="border"
                            >
                              {typeof item.descriptions === 'string' ? (
                                <p>{item.descriptions}</p>
                              ) : (
                                item?.descriptions?.map(
                                  (description: string) => (
                                    <p key={description}>{description}</p>
                                  )
                                )
                              )}
                            </td>
                          )) ||
                        (header?.field === 'period' && (
                          <td
                            key={`${header?.field}-${item.id}`}
                            className="border"
                          >
                            <p style={{ textAlign: 'left' }}>
                              {`${item.start_validity.slice(
                                0,
                                10
                              )} - ${item.end_validity.slice(0, 10)}`}
                            </p>
                          </td>
                        )) ||
                        (header?.field === 'menu_food.period' && (
                          <td
                            key={`${header?.field}-${item.id}`}
                            className="border"
                          >
                            <p style={{ textAlign: 'left' }}>
                              {`${
                                header?.field.split('.').length === 2 &&
                                item.menu_food?.start_validity.slice(0, 10)
                              }
                                  - ${
                                    header?.field.split('.').length === 2 &&
                                    item.menu_food?.end_validity.slice(0, 10)
                                  }`}
                            </p>
                          </td>
                        )) ||
                        (header?.field !== 'actions' &&
                          !header?.download &&
                          !header?.hasTypes && (
                            <td
                              key={`${header?.field}-${item.id}`}
                              className="border"
                            >
                              <p
                                style={{
                                  textAlign: 'left',
                                  whiteSpace: 'pre'
                                }}
                              >
                                {typeof item[header?.field] === 'boolean' &&
                                  (item[header?.field] ? 'Sim' : 'Não')}
                                {header?.field.split('.').length === 2 &&
                                  typeof item[header?.field.split('.')[0]]?.[
                                    header?.field.split('.')[1]
                                  ] === 'boolean' &&
                                  (item[header?.field.split('.')[0]]?.[
                                    header?.field.split('.')[1]
                                  ]
                                    ? 'Sim'
                                    : 'Não')}
                                {header?.field.split('.').length === 4 &&
                                  item[header?.field.split('.')[0]]?.[
                                    header?.field.split('.')[1]
                                  ]?.[header?.field.split('.')[2]]?.[
                                    header?.field.split('.')[3]
                                  ]}
                                {header?.field.split('.').length === 3 &&
                                  item[header?.field.split('.')[0]]?.[
                                    header?.field.split('.')[1]
                                  ]?.[header?.field.split('.')[2]]}
                                {header?.field.split('.').length === 2 &&
                                  item[header?.field.split('.')[0]]?.[
                                    header?.field.split('.')[1]
                                  ]}
                                {header?.concat
                                  ? header?.concat?.position === 'start'
                                    ? `${item[header?.concat?.field]} ${
                                        item[header?.field]
                                      }`
                                    : `${item[header?.field]} ${
                                        item[header?.concat?.field]
                                      }`
                                  : header?.field.split('.').length === 1 &&
                                    item[header?.field]}
                              </p>
                            </td>
                          )) ||
                        (header?.download && (
                          <td
                            key={`${header?.field}-${item.id}`}
                            className="border"
                          >
                            <a
                              href="#"
                              onClick={() => handleDownload(item, header)}
                              style={{
                                display: 'flex',
                                alignItems: 'flex-start'
                              }}
                            >
                              <span
                                className="fa fa-download"
                                style={{ marginRight: '5px' }}
                              ></span>
                              <span>Download</span>
                            </a>
                          </td>
                        )) ||
                        (header?.hasTypes && (
                          <td
                            key={`${header?.field}-${item.id}`}
                            className="border"
                          >
                            <p style={{ textAlign: 'left' }}>
                              {header.hasTypes.types[item[header?.field]]}
                            </p>
                          </td>
                        )) || (
                          <td
                            key={`actions-${item.id}`}
                            className="actions border"
                          >
                            {(actions && (
                              <LinkContainer>
                                {actions.map(
                                  action =>
                                    (action.hasIcon
                                      ? action.hasIcon(item)
                                      : true) && (
                                      <Link
                                        className={
                                          activeItems?.length &&
                                          activeItems.includes(item.id)
                                            ? `${action.classname} ${action.activeClassname}`
                                            : `${action.classname}`
                                        }
                                        to={
                                          action.link ||
                                          (action.linkTo &&
                                            action.linkTo(item)) ||
                                          '#'
                                        }
                                        key={action.name}
                                        title={action.title}
                                        onClick={e => {
                                          if (action.onClick) {
                                            e.preventDefault()
                                            action.onClick(item)
                                          }
                                        }}
                                      >
                                        {action.spanIcon && (
                                          <span
                                            className={action.spanIcon}
                                            style={action.style}
                                          />
                                        )}
                                        {action.icon && (
                                          <FontAwesomeIcon icon={action.icon} />
                                        )}
                                        {action.htmlIcon && action.htmlIcon}
                                      </Link>
                                    )
                                )}
                              </LinkContainer>
                            )) || (
                              <LinkContainer>
                                {showParentId && (
                                  <Link
                                    className="link"
                                    key={Math.random()}
                                    title="Visualizar"
                                    to={() => handlerOnClickButtonList(item)}
                                  >
                                    <span className="fa fa-search" />
                                  </Link>
                                )}
                                {!showParentId && (
                                  <Link
                                    className="link"
                                    key={Math.random()}
                                    title="Visualizar"
                                    to={() => handlerOnClickButtonList(item)}
                                  >
                                    <span className="fa fa-search" />
                                  </Link>
                                )}
                                <div>
                                  {!onlyView && (
                                    <Link
                                      className="link"
                                      key={Math.random()}
                                      title="Editar"
                                      onClick={e => {
                                        if (onActions?.onClickButtonEdit) {
                                          e.preventDefault()
                                          onActions.onClickButtonEdit(item)
                                        }
                                      }}
                                      to={() => handlerOnClickButtonEdit(item)}
                                    >
                                      <span className="fa fa-edit" />
                                    </Link>
                                  )}
                                  {!notHasChildren && (
                                    <a
                                      href="#"
                                      key={Math.random()}
                                      title="Remover"
                                      className="link"
                                      onClick={() => {
                                        handlerOnClickButtonRemove(item)
                                      }}
                                    >
                                      <span className="fa fa-remove" />
                                    </a>
                                  )}
                                </div>
                              </LinkContainer>
                            )}
                          </td>
                        )
                    )}
                  </tr>
                )
              })) || (
              <tr>
                <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                  Nenhum registro encontrado
                </td>
              </tr>
            )}
          </tbody>
          <tfoot />
        </table>
      </div>
      <div className="d-flex flex-stack align-items-end h-60px">
        <div className="">
          <div className="dataTables_info" id="kt_datatable">
            Mostrando de {firstItem} até {getTotalItems(firstItem)} de{' '}
            {totalItems} {totalItems === 1 ? 'registro' : 'registros'}
          </div>
        </div>
        <div className="">
          <div className="dataTables_paginate paging_bootstrap_number">
            <Pagination
              total={totalItems}
              itemsPerPage={ItemsPerPage}
              currentPage={currentPage}
              onPageChange={page => setCurrentPage(page)}
              setIsPageChanged={setPageChange}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DataTable
